export enum StockTypesEnum {
    Dispatch = 'Dispatch',
    RE_PACK = 'Re Packing',
    RE_PROCESS = 'Re Processing',
    RE_WORK = 'Re Work',
    LAB_SAMPLES = 'LAB SAMPLES',
    COMPLEMENTS = 'COMPLEMENTS'
}